document.addEventListener("DOMContentLoaded", function () {
	// This function will be called for each section separately
	function initTextTruncate() {
		// Find all text-truncate elements within the document
		const textTruncates = document.querySelectorAll(".text-truncate");

		textTruncates.forEach((text) => {
			// Reset any previous state
			text.classList.remove("expanded", "truncated");

			// The showMore button is the next sibling of the text-truncate div
			const showMoreBtn = text.nextElementSibling;

			// Only proceed if we have a showMore button
			if (!showMoreBtn || !showMoreBtn.classList.contains("showMore")) {
				return;
			}

			// Remove any existing event listeners (to prevent duplicates)
			const newBtn = showMoreBtn.cloneNode(true);
			showMoreBtn.parentNode.replaceChild(newBtn, showMoreBtn);

			// Force a reflow to get accurate height measurements
			text.style.maxHeight = "none";
			void text.offsetHeight; // Force reflow
			const fullHeight = text.scrollHeight;

			// Apply truncated style temporarily to measure truncated height
			text.style.maxHeight = "160px";
			text.style.overflow = "hidden";
			void text.offsetHeight; // Force reflow
			const truncatedHeight = text.clientHeight;

			// Reset styles
			text.style.maxHeight = "";
			text.style.overflow = "";

			// Only show button if content is actually being truncated (more than 10px difference)
			if (fullHeight > 160 && fullHeight - truncatedHeight > 10) {
				text.classList.add("truncated");
				newBtn.style.display = "block";
				newBtn.textContent = newBtn.dataset.showMore;

				// Add click handler to the showMore button
				newBtn.addEventListener("click", function (e) {
					e.preventDefault();
					text.classList.toggle("expanded");
					text.classList.toggle("truncated");

					// Update button text based on state
					this.textContent = text.classList.contains("expanded")
						? this.dataset.showLess
						: this.dataset.showMore;
				});
			} else {
				newBtn.style.display = "none";
			}
		});
	}

	// Initialize on page load
	initTextTruncate();

	// Re-initialize on window resize to handle responsive changes
	let resizeTimer;
	window.addEventListener("resize", function () {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(initTextTruncate, 250);
	});
});
